import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    error: [],
    loading: false,
    data: false
};

const slice = createSlice({
    name: "courseReview",
    initialState,
    reducers: {
        CourseReviewRequest: (courseReview) => {
            courseReview.loading = true;
            courseReview.error = false;
        },
        CourseReviewClear: (courseReview) => {
            courseReview.error = false;
            courseReview.loading = false;
        },
        CourseReviewSuccess: (courseReview, action) => {
            courseReview.loading = false;
            courseReview.error = false;
            courseReview.data = action.payload;
        },
        CourseReviewError: (courseReview, action) => {
            courseReview.loading = false;
            courseReview.error = action.payload;
        }
    }
});

export const { CourseReviewClear, CourseReviewRequest, CourseReviewSuccess, CourseReviewError } = slice.actions;

export default slice.reducer;
